export const ADD_lOG: string = "ADD_LOG";
export const CLEAR_LOGS: string = "CLEAR_LOGS";
export function addLog(log_id:string,toNumber: string,
    createdAt:string,
    verifiedAt:string,
    attempts:number,
    status:number,
    name:string,
    channel:number,
    sub_created_At:string,
    id_Log:string): IAddLogActionType {
    return { type: ADD_lOG, log_id:log_id,toNumber:toNumber,createdAt: createdAt, verifiedAt:verifiedAt,attempts:attempts,name:name,channel:channel, sub_created_At:sub_created_At, id_Log: id_Log, status:status };
}
export function clearLogs(): IClearLogActionType {
    return { type: CLEAR_LOGS};
}

interface IAddLogActionType { 
    log_id:string, 
    type:string, 
    toNumber: string, 
    createdAt:string, 
    verifiedAt:string, 
    attempts:number, 
    status:number, 
    name:string, 
    channel:number, 
    sub_created_At:string, 
    id_Log:string 
}

interface IClearLogActionType { 
    type:string 
}